import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

function GalleriaCard() {

  // Rileva se la finestra è più piccola di 768px (tipico tablet/mobile)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    {
      original: "https://i.imgur.com/4f3Uo8K.jpeg",
      thumbnail: "https://i.imgur.com/4f3Uo8K.jpeg",
      description: "Ospedale, 23/09/2021"
    },
    {
      original: "https://i.imgur.com/dwpJe0p.jpeg",
      thumbnail: "https://i.imgur.com/dwpJe0p.jpeg",
      description: "Magazzino, 16/08/2022"
    },
    {
      original: "https://i.imgur.com/IO4M6uD.jpeg",
      thumbnail: "https://i.imgur.com/IO4M6uD.jpeg",
      description: "Festeggiamenti di 1 anno di carriera in magazzino, 06/07/2023"
    },
    {
      original: "https://i.imgur.com/2IkHwiS.jpeg",
      thumbnail: "https://i.imgur.com/2IkHwiS.jpeg",
      description: "Terza missione di scavo, 23/07/2023"
    },
    {
      original: "https://i.imgur.com/ANOH5fq.jpeg",
      thumbnail: "https://i.imgur.com/ANOH5fq.jpeg",
      description: "Compleanno, 26/08/2023"
    },
    {
      original: "https://i.imgur.com/VL7J32r.jpeg",
      thumbnail: "https://i.imgur.com/VL7J32r.jpeg",
      description: "SwipeUp, 17/09/2023"
    },
    {
      original: "https://i.imgur.com/NbyD6X4.jpeg",
      thumbnail: "https://i.imgur.com/NbyD6X4.jpeg",
      description: "Nomina a Direttore del Magazzino, con i vice _N0N4m3 e Francy__358, 07/11/2023"
    },
    {
      original: "https://i.imgur.com/KtUfeFh.jpeg",
      thumbnail: "https://i.imgur.com/KtUfeFh.jpeg",
      description: "SteakHouse, 26/11/2023"
    },
    {
      original: "https://i.imgur.com/zOK7erw.jpeg",
      thumbnail: "https://i.imgur.com/zOK7erw.jpeg",
      description: "Evento Magazzino Awards presso lo SteakHouse, 14/05/2023"
    },
    {
      original: "https://i.imgur.com/IFevuTp.jpeg",
      thumbnail: "https://i.imgur.com/IFevuTp.jpeg",
      description: "Giuramento del Governo Leroux I, 06/08/2024"
    },
    {
      original: "https://i.imgur.com/cXqbVAz.jpeg",
      thumbnail: "https://i.imgur.com/cXqbVAz.jpeg",
      description: "Giuramento del Governo Leroux I, 06/08/2024"
    },
    {
      original: "https://i.imgur.com/s7HxjSL.jpeg",
      thumbnail: "https://i.imgur.com/s7HxjSL.jpeg",
      description: "Visita istituzionale presso l'Ispettorato del Lavoro, 12/08/2024"
    },
    {
      original: "https://i.imgur.com/CbKSHg3.jpeg",
      thumbnail: "https://i.imgur.com/CbKSHg3.jpeg",
      description: "Cessione del Magazzino al neo-Direttore _N0N4m3, 24/08/2024"
    },
    {
      original: "https://i.imgur.com/mqYrdhV.jpeg",
      thumbnail: "https://i.imgur.com/mqYrdhV.jpeg",
      description: "Laurea in Informatica con 110 e lode, 27/08/2024"
    },
    {
      original: "https://i.imgur.com/iFnbga3.jpeg",
      thumbnail: "https://i.imgur.com/CbKSHg3.jpeg",
      description: "Laurea in Informatica con 110 e lode, 27/08/2024"
    },
    {
      original: "https://i.imgur.com/tUN7Cyg.jpeg",
      thumbnail: "https://i.imgur.com/tUN7Cyg.jpeg",
      description: "Visita istituzionale presso il Magazzino, 09/09/2024"
    },
    {
      original: "https://i.imgur.com/sU9zWfR.jpeg",
      thumbnail: "https://i.imgur.com/sU9zWfR.jpeg",
      description: "Visita istituzionale presso la Guardia di Finanza, 11/09/2024"
    },
    {
      original: "https://i.imgur.com/j6NExzU.jpeg",
      thumbnail: "https://i.imgur.com/j6NExzU.jpeg",
      description: "Visita istituzionale presso la Pasticceria Sweet, 12/09/2024"
    },
    {
      original: "https://i.imgur.com/rjnhDiN.jpeg",
      thumbnail: "https://i.imgur.com/rjnhDiN.jpeg",
      description: "Visita istituzionale presso lo SteakHouse, 12/09/2024"
    },
    {
      original: "https://i.imgur.com/Uleu7LF.jpeg",
      thumbnail: "https://i.imgur.com/Uleu7LF.jpeg",
      description: "Visita istituzionale presso l'Ikea, 14/09/2024"
    },
    {
      original: "https://i.imgur.com/9IqCMG2.jpeg",
      thumbnail: "https://i.imgur.com/9IqCMG2.jpeg",
      description: "Visita istituzionale presso il Tasty Burger, 15/09/2024"
    },
    {
      original: "https://i.imgur.com/jxHJR73.jpeg",
      thumbnail: "https://i.imgur.com/jxHJR73.jpeg",
      description: "Visita istituzionale presso l'Officina, 16/09/2024"
    },
    {
      original: "https://i.imgur.com/OOU11w9.jpeg",
      thumbnail: "https://i.imgur.com/OOU11w9.jpeg",
      description: "Visita istituzionale presso l'Autoscuola, 29/09/2024"
    },
    {
      original: "https://i.imgur.com/Ee6PqJZ.jpeg",
      thumbnail: "https://i.imgur.com/Ee6PqJZ.jpeg",
      description: "Giuramento del Governo Ehrmantraut I, 14/10/2024"
    },
    {
      original: "https://i.imgur.com/EUUGCWB.jpeg",
      thumbnail: "https://i.imgur.com/EUUGCWB.jpeg",
      description: "Nomina a Sottosegretario alla Vice Presidenza di Stato, 08/11/2024"
    },
    {
      original: "https://i.imgur.com/Xk2WNWX.jpeg",
      thumbnail: "https://i.imgur.com/Xk2WNWX.jpeg",
      description: "Sede Equilibrium Party, 15/11/2024"
    },
    {
      original: "https://i.imgur.com/bgSUEKb.jpeg",
      thumbnail: "https://i.imgur.com/bgSUEKb.jpeg",
      description: "Palazzo Sant'Ayama, 15/11/2024"
    },
    {
      original: "https://i.imgur.com/wiM6RTb.jpeg",
      thumbnail: "https://i.imgur.com/wiM6RTb.jpeg",
      description: "Visita istituzionale presso l'Officina, 23/11/2024"
    },
    {
      original: "https://i.imgur.com/wITRyzI.jpeg",
      thumbnail: "https://i.imgur.com/wITRyzI.jpeg",
      description: "Visita istituzionale presso il Tasty Burger, 07/12/2024"
    },
    {
      original: "https://i.imgur.com/OUqQRlC.jpeg",
      thumbnail: "https://i.imgur.com/OUqQRlC.jpeg",
      description: "Visita istituzionale presso l'Ikea, 20/12/2024"
    },
    {
      original: "https://i.imgur.com/Ft90Kje.jpeg",
      thumbnail: "https://i.imgur.com/Ft90Kje.jpeg",
      description: "Giuramento del Governo Beezy II, 23/12/2024"
    },
    {
      original: "https://i.imgur.com/CB5ynoB.jpeg",
      thumbnail: "https://i.imgur.com/CB5ynoB.jpeg",
      description: "Babbo Natale segreto al CUS dell'Università Santa Helenie, 28/12/2024"
    },
    {
      original: "https://i.imgur.com/161Xu31.jpeg",
      thumbnail: "https://i.imgur.com/161Xu31.jpeg",
      description: "Matrimonio con _Noyla_, 06/01/2025"
    },
    {
      original: "https://i.imgur.com/SC8LSfQ.jpeg",
      thumbnail: "https://i.imgur.com/SC8LSfQ.jpeg",
      description: "Visita istituzionale presso la Guardia di Finanza, 14/01/2025"
    },
    {
      original: "https://i.imgur.com/tUYBxfc.jpeg",
      thumbnail: "https://i.imgur.com/tUYBxfc.jpeg",
      description: "Visita istituzionale presso l'Accademia Militare Centauros dell'SMD, 23/01/2025"
    },
    {
      original: "https://i.imgur.com/omuuLQb.jpeg",
      thumbnail: "https://i.imgur.com/omuuLQb.jpeg",
      description: "Dibattito Politico, 24/01/2025"
    },
    {
      original: "https://i.imgur.com/OoinOeG.jpeg",
      thumbnail: "https://i.imgur.com/OoinOeG.jpeg",
      description: "Visita istituzionale presso la Pasticceria Sweet, 31/01/2025"
    },
    {
      original: "https://i.imgur.com/I2E6iYO.jpeg",
      thumbnail: "https://i.imgur.com/I2E6iYO.jpeg",
      description: "Visita Istituzionale SwipeUp, 14/06/2025"
    },
    {
      original: "https://i.imgur.com/6m2NSs1.jpeg",
      thumbnail: "https://i.imgur.com/6m2NSs1.jpeg",
      description: "SwipeUp, 03/07/2025"
    },
    {
      original: "https://i.imgur.com/3BklK25.jpeg",
      thumbnail: "https://i.imgur.com/3BklK25.jpeg",
      description: "Matrimonio con zAkhlus_, 24/08/2025"
    },
    {
      original: "https://i.imgur.com/5dGA33B.jpeg",
      thumbnail: "https://i.imgur.com/5dGA33B.jpeg",
      description: "Compleanno, 26/08/2025"
    },
    {
      original: "https://i.imgur.com/E4WzFGW.jpeg",
      thumbnail: "https://i.imgur.com/E4WzFGW.jpeg",
      description: "SwipeUp, 07/12/2025"
    },
    {
      original: "https://i.imgur.com/VTKKkO9.jpeg",
      thumbnail: "https://i.imgur.com/VTKKkO9.jpeg",
      description: "Visita Istituzionale SwipeUp, 21/12/2025"
    },
    {
      original: "https://i.imgur.com/cuI5xJ1.jpeg",
      thumbnail: "https://i.imgur.com/cuI5xJ1.jpeg",
      description: "Visita Istituzionale SwipeUp, 21/12/2025"
    },
    {
      original: "https://i.imgur.com/pvmIvhx.jpeg",
      thumbnail: "https://i.imgur.com/pvmIvhx.jpeg",
      description: "Visita Istituzionale SwipeUp, 21/12/2025"
    },
    {
      original: "https://i.imgur.com/Gk4vX5R.jpeg",
      thumbnail: "https://i.imgur.com/Gk4vX5R.jpeg",
      description: "Piazza Centrale, 21/12/2025"
    },
    {
      original: "https://i.imgur.com/G0IOMjN.jpeg",
      thumbnail: "https://i.imgur.com/G0IOMjN.jpeg",
      description: "Cena di fine anno della SwipeUp presso il Bistrot, 29/12/2025"
    },
    {
      original: "https://i.imgur.com/zRaWS2E.jpeg",
      thumbnail: "https://i.imgur.com/zRaWS2E.jpeg",
      description: "Cena di fine anno della SwipeUp presso il Bistrot, 29/12/2025"
    },
    {
      original: "https://i.imgur.com/SgylHpc.jpeg",
      thumbnail: "https://i.imgur.com/SgylHpc.jpeg",
      description: "Cena di fine anno della SwipeUp presso il Bistrot, 29/12/2025"
    },
    {
      original: "https://i.imgur.com/EiwlVov.jpeg",
      thumbnail: "https://i.imgur.com/EiwlVov.jpeg",
      description: "Cessione della SwipeUp al neo-Direttore ImSebii, 12/01/2026"
    },
    {
      original: "https://i.imgur.com/9w2Nrur.jpeg",
      thumbnail: "https://i.imgur.com/9w2Nrur.jpeg",
      description: "SwipeUp, 12/01/2026"
    },
    {
      original: "https://i.imgur.com/8P9qxM1.jpeg",
      thumbnail: "https://i.imgur.com/8P9qxM1.jpeg",
      description: "Nuova Direzione SwipeUp, 14/01/2026"
    },
    {
      original: "https://i.imgur.com/1mokI0T.jpeg",
      thumbnail: "https://i.imgur.com/1mokI0T.jpeg",
      description: "Evento Democracy Edge di Politics, 24/01/2026"
    },
    {
      original: "https://i.imgur.com/gekxMXj.jpeg",
      thumbnail: "https://i.imgur.com/gekxMXj.jpeg",
      description: "Evento Democracy Edge di Politics, 24/01/2026"
    },
    {
      original: "https://i.imgur.com/VpFMSfY.jpeg",
      thumbnail: "https://i.imgur.com/VpFMSfY.jpeg",
      description: "Evento Democracy Edge di Politics, 24/01/2026"
    },
  ];

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <ImageGallery 
          items={images} 
          // Configurazioni
          infinite={true}              // allow infinite sliding
          showFullscreenButton={!isMobile}  // show fullscreen button
          showPlayButton={false}       // show play button 
          showBullets={false}            // show bullets
          showThumbnails={!isMobile}         // show thumbnails
          showNav={true}               // show navigation
          showIndex={false}            // show index 
          slideOnThumbnailOver={false} // slide on mouse over thumbnails 
          useWindowKeyDown={true}      // use window keydown
        />
      </Card.Body>
    </Card>
  );
}

export default GalleriaCard;